import React, {
  useEffect
} from 'react';
import styled from 'styled-components';
import FormInput from '../molecules/FormInput';
import FormTitle from '../molecules/FormTitle';
import { isValidPhoneNumber } from 'libphonenumber-js';

import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

const ContactInfo = ({ register, errors, trigger, setValue, watch }: any) => {


  const mobile = watch('mobile'); // Watch phone manually

  useEffect(() => {
    register('mobile', {
      required: 'MOBILE NUMBER IS REQUIRED',
      validate: (value: string) =>
        isValidPhoneNumber(value || '') || 'INVALID PHONE NUMBER',
    });
  }, [register]);
  
  return (
    <Form>
      <FormTitle title={'CONTACT INFORMATION'} />
      <FormInput
        type="email"
        placeholder="EMAIL"
        {...register('email', { 
          required: `Field is required`.toUpperCase(),
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Basic email regex
            message: 'Enter a valid email address'.toUpperCase(),
          }, 
        })}
      />
      {errors.email && <ErrorText>{errors.email.message}</ErrorText>}

      <PhoneInputStyled
        value={mobile}
        onChange={(value: any) => {
          setValue('mobile', value);
          trigger('mobile'); // Validate on change
        }}
        defaultCountry="PH"
        international
        countryCallingCodeEditable={false}
        placeholder="Enter phone number"
      />

      {errors.mobile && <ErrorText>{errors.mobile.message}</ErrorText>}
    </Form>
  );
};

const Form = styled.div`
  padding: 0.5rem 0rem;
`;

const ErrorText = styled.span`
  color: red;
  font-size: 0.75rem;
`;

const PhoneInputStyled = styled(PhoneInput)`

  input {
    width: 100%;
    font-family: 'Poppins-Medium';
    font-size: 0.8rem;
    padding: 0.6rem 0.8rem;
    border-radius: 6px;
    appearance: none;
    outline: none;
    border: 1px solid #ccc;
  }
`;

export default ContactInfo;
